import { Component, Output, EventEmitter, HostListener, ElementRef, Input, OnInit } from '@angular/core';

export enum Position {
  above = 'above',
  below = 'below',
  right = 'right',
  left = 'left'
}

@Component({
  selector: 'app-select',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropDownComponent implements OnInit {


  @Output() sendSearch = new EventEmitter<any>();
  @Output() clearDropDown = new EventEmitter<any>();

  /**
   *
   * @exemple in EditModalSearchProfileComponent html
   *
   */

  /**
   * @param [field] List attribute that will be shown in the dropdown
   */
  @Input() public field: string;
  /**
   * @param [height] Dropdown size in px - Default 250 height
   */
  @Input() public height = 250;
  /**
   * @param [sizeList] this parameter applies a flag to the search input.
   */
  @Input() public sizeList = 3;
  /**
   * @see
   * NÃO É OBRIGATÓRIO.
   * Este parametro fornecerá uma segunda optição para visualização no dropdown
   * que não será enviado através de um objeto.
   *
   * @param [textOptions] this parameter applies a flag to the search input.
   * @exemplos field === equal ? default : alterantive;
   */
  @Input() public textOptions ?= {
    field: '',
    equal: '',
    default: '',
    alternative: ''
  };

  @Input() public inputHeight = '44px';

  @Input() public listItems = [];
  @Input() public labelText = '';
  @Input() public placeholder = 'Selecione';
  @Input() public disabled = false;
  @Input() public textTitle = '';
  @Input() public showSearch = true;
  @Input() public isRelative: false;
  @Input() public position: Position = Position.below;

  elHeight: number;
  public text = '';
  public fieldSeach = '';
  public showList = false;
  public listView = [];

  // select
  public index = -1;

  ngOnInit() {
    this.resize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resize();
  }

  @HostListener('document:keydown', ['$event'])
  onClick(ev: KeyboardEvent) {
    if (ev.code === 'Escape') {
      this.showList = false;
    }
  }

  private resize(): void {
    this.elHeight = this.eRef.nativeElement.getBoundingClientRect().width;
  }

  constructor(
    private eRef: ElementRef
  ) {  }

  public openList() {
    if (this.disabled) {
      return;
    }
    this.showList = !this.showList;
    this.text = '';
    this.index = -1;
    this.fieldSeach = '';
  }

  public textField(item): string {
    return item[this.textOptions.field] === this.textOptions.equal ? this.textOptions.alternative : this.textOptions.default;
  }

  public clearTitle(event: Event): void {
    event.stopPropagation();
    this.textTitle = '';
    this.text = '';
    this.index = -1;
    this.clearDropDown.emit();
  }

  public searchData(): void {
    this.listItems.forEach(x => {
      if (this.typeValidator(x).toLowerCase() === this.text.trim().toLowerCase()) {
        this.sendText(x);
      }
    });
  }

  public sendText(data): void {
    if (data) {
      this.showList = false;
      this.sendSearch.emit(data);
      this.textTitle = this.typeValidator(data);
      this.text = '';
      this.index = -1;
    }
  }

  public typeValidator(data) {
    return this.field ? data[this.field].trim() : data;
  }

  public searchInput(data: string): void {
    this.index = -1;
    this.fieldSeach = data.normalize('NFD').trim().toLowerCase();
  }

  public sendNewList(): any [] {
    if (!this.fieldSeach.length) {
      return this.listItems;
    }
    return this.filterList();
  }

  public filterList(): any [] {
    return this.listItems.filter(x => this.field ?
      x[this.field].normalize('NFD').toLowerCase().includes(this.fieldSeach)
      :
      x.normalize('NFD').toLowerCase().includes(this.fieldSeach));
  }

  public downList(event: KeyboardEvent | any) {
    this.listView = this.sendNewList();
    this.leaveEsc(event.keyCode);
    this.validKeyCode(event);
    if (event.keyCode === 13 && this.listView.length) {
      this.sendText(this.listView[this.index]);
    }
  }

  public leaveEsc(data: number): boolean {
    if (data === 27) {
      this.showList = false;
      return false;
    }
  }

  public validKeyCode(data: KeyboardEvent): boolean {
    if ((data.keyCode === 40 || data.keyCode === 38)) {
      if (this.indexFilter(this.index, this.listView.length, data, 40, 38)) {
        return false;
      }
      this.validIndex(data.keyCode);
    }
  }

  public validIndex(data: number): boolean {
    if (data === 40) {
      this.index += 1;
      return false;
    }
    if (data === 38) {
      this.index -= 1;
      return false;
    }
  }

  public indexFilter(index: number, listLength: number, event: KeyboardEvent | any, numberDown: number, numberUp: number): boolean {
    if ((index + 1 >= listLength) && event.keyCode === numberDown) {
      return true;
    }
    if ((index <= 0) && event.keyCode === numberUp) {
      return true;
    }
    return false;
  }


}